import { useState, useEffect, ReactElement } from "react";
import { T } from "react-translator-component";
import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/store";
import { setErrorObj } from "../../redux/errorReducer";
import { isAdmin } from "../../util/util";
import apiServices from "../../services/apiServices";
import LoadingModal from "../../../components/LoadingModal";
import FormDialog from "../FormDialog";
import CreateUpdateButton from "../CreateUpdateButton";
import { colors } from "../../../common/colors";

interface Props {
  group?: any;
  show: boolean;
  onReload: () => void;
  onClose: () => void;
}

export default function GroupForm({group, show, onReload, onClose}: Props): ReactElement {
  const { admin } = useSelector((state: any) => state.adminAuth);
  const dispatch = useAppDispatch();
  const [loader, setLoader] = useState<boolean>(false);
  const [groupName, setGroupName] = useState<string>("");

  useEffect(() => {
    if (!show) setGroupName("")

    setGroupName(group?.name ?? "")
  }, [show, group])

  const handleSubmit = async () => {
    if (!isAdmin(admin)) return false

    try {
      setLoader(true);
      if (group?.id) {
        await apiServices.updateGroup(groupName, group.id);
      } else {
        await apiServices.createGroup(groupName);
      }
      onReload();
      onClose();
      return true
    } catch (error: any) {
      dispatch(setErrorObj(error))
      return false
    } finally {
      setLoader(false);
    }
  }

  return (
    <>
      <LoadingModal visible={loader} />

      <FormDialog open={show} onClose={() => onClose()}>
        <div style={styles.groupDialogContainer}>
          <div style={styles.groupDialogContainer}>
            <span style={styles.groupTitleName}>
              {group?.id ? T("mng_edit_group") : T("mng_group_name")}
            </span>

            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              value={groupName}
              placeholder={T("mng_group_placeholder")[0]}
              onChange={(e: any) => setGroupName(e.target.value)}
              style={styles.groupTextField}
            />
          </div>

          <CreateUpdateButton
            title={group?.id ? T("mng_save") : T("mng_create_group_button")}
            disabled={groupName === ""}
            validate={async () => groupName !== ""}
            onSubmit={() => handleSubmit()}
          />
        </div>
      </FormDialog>
    </>
  );
}

const styles = {
  groupDialogContainer: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    margin: "20px 0"
  },
  groupTitleName: {
    fontSize: 16,
    color: colors.farm_blue200,
    marginBottom: 20,
    fontWeight: "500",
  },
  groupTextField: {
    fontSize: 14,
    padding: 0,
    marginBottom: 10,
    width: "400px"
  },
}
